import {
  valid,
  refreshToken,
  ajax,
  serviceAjax,
  downloadAjax,
  header
} from './base'
import config from '../../config'

const reports = {

  async CreateExportTask(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ExportTask/Create',
      type: 'post',
      data
    })
    return response
  },
  async GetExportTaskList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ExportTask/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async DeleteExportTask(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/ExportTask/Delete',
      type: 'post',
      data
    })
    return response
  },
  async ExportDownload(data = {}) {
    const response = await downloadAjax({
      url: '/api/File/ExportDownload?fileId=' + data.fileId,
      type: 'get',
      fileName: data.fileName
    })
    return response
  },
}
export default reports



// WEBPACK FOOTER //
// ./src/common/api/reports.js